<template>
  <div class="company-role-bd ub">
    <div class="aside ubv">
      <div class="title">
        <span>{{ $t('company_role.gang_wei') }}</span>
      </div>
      <div class="ub-f1 ubv">
        <div class="search">
          <div class="ub">
            <div class="ub-f1">
              <search-input width="100%" :placeholder="$t('company_role.gang_wei_ming_cheng')" v-model="appKey"></search-input>
            </div>
            <el-button v-if="funcView.role_add" style="padding: 0 13px !important; margin-left: 16px" type="warning" circle icon="icon icon-tianjia" @click="addRole()"></el-button>
          </div>
        </div>
        <div class="list ub-f1">
          <custom-tree
            default
            :data="roleList"
            node-key="roleId"
            :listener="appKey"
            :filterKeys="['roleName']"
            :props="{ label: 'roleName' }"
            v-model="roleData"
            :action="treeAction"
            @edit="editRole"
            @delete="deleteRole"
            @state="changeStateRole"
          ></custom-tree>
        </div>
      </div>
      <div class="title" v-if="sysRoleList && sysRoleList.length">
        <span>{{ $t('company_role.xi_tong_gang_wei') }}</span>
      </div>
      <div class="ub-f1" v-if="sysRoleList && sysRoleList.length">
        <div class="list">
          <custom-tree :data="sysRoleList" node-key="roleId" :filterKeys="['roleName']" :props="{ label: 'roleName' }" v-model="roleData"></custom-tree>
        </div>
      </div>
    </div>
    <div style="width: 1px; background: #f0f0f0"></div>
    <div class="section ubv ub-f1">
      <el-tabs v-model="active">
        <el-tab-pane v-if="funcView.role_list_user" :label="$t('company_role.gang_wei_quan_xian')" name="permission"></el-tab-pane>
        <el-tab-pane :label="$t('company_role.gang_wei_yuan_gong')" name="member"></el-tab-pane>
      </el-tabs>
      <!-- 角色权限 -->
      <role-permission class="ub-f1" v-if="active === 'permission'" :roleId="roleData.roleId" :disabled="roleData.disabled"></role-permission>
      <!-- 角色用户 -->
      <role-user v-if="active === 'member'" :roleId="roleData.roleId"></role-user>
    </div>
    <!-- 新增角色弹窗 -->
    <role-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getRoleList"></role-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customTree from '@/components/customTree.vue';
import roleUser from './children/role_user.vue';
import rolePermission from './children/role_permission.vue';
import roleDialog from './children/role_dialog.vue';

// i18n-lang-component
export default {
  name: 'company_role',
  components: { customTree, roleDialog, rolePermission, roleUser },
  data() {
    return {
      active: '',
      activeTab: '',
      roleList: [],
      sysRoleList: [],
      roleData: {},
      appKey: '',
      dialogVisible: false,
      dialogModel: {},
      startY: 0,
      moveY: 0,
      containerH: 200,
      hasDrag: false,

      dicMap: {},
      isAdmin: false,
      userInfo: {},
    };
  },
  computed: {
    treeAction() {
      return {
        state: this.funcView.role_disabled,
        edit: this.funcView.role_edit,
        delete: this.funcView.role_del,
      };
    },
  },
  mounted: function () {
    this.getRoleList();
    this.active = 'permission';
    this.activeTab = 'funcRole';
    this.getFuncView();
  },
  methods: {
    // 获取岗位列表
    getRoleList: function () {
      this.$getJSON(apis.UserRoleAll, {
        isOwnOrgan: 1,
        isShowNotice: 0,
        isShowService: 0,
      }).then((res) => {
        this.roleList = res.data;
      });
      this.$getJSON(apis.UserRole4).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.disabled = true;
        });
        this.sysRoleList = list;
      });
    },
    // 新增岗位
    addRole: function () {
      this.dialogModel = {
        type: 'add',
        title: this.$t('company_role.xin_zeng_gang_wei'),
      };
      this.dialogVisible = true;
    },
    // 编辑岗位
    editRole: function (data) {
      this.dialogModel = {
        type: 'edit',
        title: this.$t('company_role.bian_ji_gang_wei'),
        row: data,
      };
      this.dialogVisible = true;
    },
    // 删除岗位
    deleteRole: function (data) {
      this.$showConfirm(this, this.$t('company_role.nqdyscxzdgwm')).then(() => {
        this.$postJSON(`${apis.RoleDelete}/${data.roleId}`).then(() => {
          this.getRoleList();
        });
      });
    },
    // 禁止/启用岗位
    changeStateRole: function (data) {
      this.$showConfirm(this, data.state === 0 ? this.$t('company_role.nqdyqyxzdgwm') : this.$t('company_role.nqdytyxzdgwm')).then(() => {
        this.$postJSON(apis.RoleState, {
          roleId: data.roleId,
          state: data.state === 0 ? 1 : 0,
        }).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getRoleList();
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.company-role-bd {
  background-color: #ffffff;
  border-radius: 16px;
  min-height: 850px;
  .aside {
    width: 486px;
    padding: 24px;
    .title {
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      font-weight: bold;
      color: $--color-text-regular;
    }
    .search {
      margin: 24px 0;
    }
  }
  .section {
    padding: 24px 24px 0;
    .el-tabs .el-tabs__header {
      margin: 0;
    }
  }
}
</style>
